module.exports = __webpack_public_path__ + "static/media/forward_modeling_1.1ecff8aa.png";